import { AxiosInstance } from "axios";
import Endpoint from "@/utils/endpoint";
import AccountInterface from "@/types/app/accounts";
import ErrorService from "./erroService";

export default class AccountService {

  constructor(private api: AxiosInstance, private endpoint: Endpoint = new Endpoint()) { }

  async getAccounts(): Promise<AccountInterface[]> {

    try {
      const { data } = await this.api.get<AccountInterface[]>(`${this.endpoint.accountsGetAll}`);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return [];
    }

  }

  async getAccountsByInvestorId(investorId:string): Promise<AccountInterface[]> {

    try {
      const { data } = await this.api.get<AccountInterface[]>(`${this.endpoint.accountsGetByUser}/${investorId}`);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return [];
    }

  }

  async deleteAccount(accountId: string): Promise<boolean> {
    try {
      const { data } = await this.api.delete(`${this.endpoint.account}`, {
        data: { usersAccountId: [accountId] },
      });
      return data;
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  async saveAccount(account: AccountInterface, edit: boolean): Promise<boolean> {
    try {
      const { data } = !edit ? await this.api.post(this.endpoint.account, account) : await this.api.put(this.endpoint.account, account);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return false;
    }
  }

  async saveAccounts(accounts: AccountInterface[]): Promise<boolean> {
    try {
      const { data } = await this.api.post(this.endpoint.account + '/import-accounts', accounts);
      return data;
    } catch (error) {
      ErrorService.onError(error);
      return false;
    }
  }
}